<p-confirmDialog key="confirmassign" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="assign" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstLocker"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedLocker"
		dataKey="LockerID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--LockerNum-->
				<th>
					<p-columnFilter type="text" field="LockerNum" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--Comment-->
				<th>
					<p-columnFilter type="text" field="Comment" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--AssignedComment-->
				<th>
					<p-columnFilter type="text" field="AssignedComments" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--Student-->
				<th>
					<p-columnFilter type="text" field="Student" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="LockerNum">Locker<p-sortIcon field="LockerNum"></p-sortIcon></th>
				<th pSortableColumn="Comment">Locker Comment<p-sortIcon field="Comment"></p-sortIcon></th>
				<th pSortableColumn="AssignedComments">Assign Comment<p-sortIcon field="AssignedComments"></p-sortIcon></th>
				<th pSortableColumn="PersonID">Student<p-sortIcon field="PersonID"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Locker>
			<tr [pSelectableRow]="Locker" (dblclick)="onRowDblClick(Locker)">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ Locker[col.field] }}
				</td>

				<!--Comment-->
				<td>
					<textarea
						[disabled]="IsLoading() == true"
						class="form-control"
						[(ngModel)]="Locker.AssignedComments"
						placeholder="Locker Combination and notes Ex. 0-0-0"
					></textarea>
				</td>

				<!--Select Student-->
				<td style="position: absolute">
					<!-- <select [disabled]="IsLoading() == true" class="form-control" [(ngModel)]="Locker.PersonID">
						<option *ngFor="let r of lstStudents" [ngValue]="r.PersonID">{{r.PersonName}}</option>
					</select> -->

					<div>
						<p-dropdown
							[optionDisabled]="IsLoading() == true"
							[options]="lstStudents"
							optionLabel="PersonName"
							optionValue="PersonID"
							[(ngModel)]="Locker.PersonID"
							[filter]="true"
						></p-dropdown>
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAssign()">Assign</button>
	<button [disabled]="processing == true" class="btn btn-primary" (click)="onClose()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin" style="margin-bottom: 110px">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
